<div class="grid-container full-height full v-pad">
  @if (correctionData.length > 0) {
    <div class="user-form-max-width">
      <h4>{{objectEntity.entityName}} Object</h4>
      @if (isInReviewMode) {
        <div>
          @if (isInReviewMode) {
            <button class="button margin-left" [disabled]="!dataChangeForm.valid" (click)="toggleOnlyAlteredFields()">
            {{viewAllButtonText}}</button>
          }
        </div>
      }
      <form [formGroup]="dataChangeForm">
        <div formGroupName="entity">
          @for (dModel of correctionData; track dModel) {
            <div>
              <data-correction-input [isInReviewMode] = "isInReviewMode" [correctionData]="dModel" [correctionDataInstance]="correctionDataInstance"
                [formGroup]="dataChangeForm.get('entity')" [showOnlyAlteredFields]="showOnlyAlteredFields"
                (updatedCorrectionData)="onInputCorrectionDataUpdated($event)"
              (correctionDataArrayChanged)="onCorrectionDataArrayChanged($event)"></data-correction-input>
            </div>
          }
        </div>
        @if (!isInReviewMode) {
          <div class="cell large-12">
            Upload Accompanying Documentation<span [ngClass]="{ 'red': dataChangeForm.get('uploadedFile').invalid, 'bold': dataChangeForm.get('uploadedFile').invalid }"></span>:
          </div>
        }
        @if (isInReviewMode && correctionDataInstance.uploadedFiles.length > 0) {
          <div class="cell large-12">
            Uploaded Accompanying Documentation<span [ngClass]="{ 'red': dataChangeForm.get('uploadedFile').invalid, 'bold': dataChangeForm.get('uploadedFile').invalid }"></span>:
          </div>
        }
        <div class="cell large-12 minor-margin-bottom">
          @if (!isInReviewMode) {
            <upload-view-files [isPadded]="false" (newFilesList)="savedFiles($event)"></upload-view-files>
          }
          @if (hasFileListing) {
            <div class="file-list padding-all-small">
              <h3 class="minor-margin-bottom h6">Uploaded Files</h3>
              @for (file of correctionDataInstance.uploadedFiles; track file) {
                <div class="flex">
                  <uploaded-file [allowFileDeletion]="!submitComplete" [file]="file" (fileDeleted)="deleteFile($event)"></uploaded-file>
                </div>
              }
            </div>
          }
        </div>
        <!--COMMENTED OUT FOR NOW IN CASE THEY CHANGE MIND AND WANT TO PICK-->
        <!--<div class="cell large-3">
        Type of Document<span [ngClass]="{ 'red': dataChangeForm.get('docType').invalid, 'bold': dataChangeForm.get('docType').invalid }">*</span>:
      </div>
      <div class="cell large-9">
        <select *ngIf="documentTypes" id="docType" formControlName="docType" (change)="validateForm()">
          <option *ngFor="let doc of documentTypes" [value]="doc.value">{{doc.displayName
          }}</option>
        </select>
        <ng-container *ngIf="documentTypes == null">
          <text-loader [run]="runDocumentLoader" [text]="'Loading Document Types'" [tickType]="'.'" [interval]="1000"></text-loader>
        </ng-container>
      </div>-->
      <div class="cell small-8">
        Notes:
        <textarea id="DataCorrectionNotes" formControlName="notes" [(ngModel)]="correctionDataInstance.notes" [attr.disabled]="!isInReviewMode  ? null : 'disabled'"
        style="resize: none; height: 100px;"></textarea>
      </div>
      @if (isInReviewMode || correctionDataInstance.reviewNotes) {
        <div class="cell small-8">
          Review Notes:
          <textarea id="DataCorrectionReviewNotes" formControlName="reviewNotes" [(ngModel)]="correctionDataInstance.reviewNotes"
            [attr.disabled]="isInReviewMode && correctionDataInstance.status !== 'Denied' && correctionDataInstance.status !== 'Approved'  ? null : 'disabled'"
          style="resize: none; height: 100px;"></textarea>
        </div>
      }
    </form>
    @if (correctionDataInstance.status !== 'Denied' && correctionDataInstance.status !== 'Approved' && adHocReviewWorkOrderId) {
      <div>
        @if (isInReviewMode) {
          <button class="button margin-left" [disabled]="!dataChangeForm.valid" (click)="adHocApprove()">Approve</button>
        }
        @if (isInReviewMode) {
          <button class="button margin-left" [disabled]="!dataChangeForm.valid" (click)="adHocReturn()">Return to Previous Reviewer</button>
        }
      </div>
    }
    @if (correctionDataInstance.status !== 'Denied' && correctionDataInstance.status !== 'Approved') {
      <div>
        @if (!isInReviewMode && !adHocReviewWorkOrderId) {
          <button class="button margin-right" [disabled]="!dataChangeForm.valid" (click)="save()">Save current changes</button>
        }
        @if (!isInReviewMode && !adHocReviewWorkOrderId) {
          <button class="button margin-left" [disabled]="!dataChangeForm.valid" (click)="submit()">Submit for Review</button>
        }
        @if (isInReviewMode) {
          <button class="button margin-left" [disabled]="!dataChangeForm.valid" (click)="saveAndReturnToDashboard()">Save</button>
        }
        @if (isInReviewMode && !adHocReviewWorkOrderId) {
          <button class="button margin-left" [disabled]="!dataChangeForm.valid" (click)="return()">Return for Corrections</button>
        }
        @if (isInReviewMode && !adHocReviewWorkOrderId) {
          <button class="button margin-left" [disabled]="!dataChangeForm.valid" (click)="approve()">Approve</button>
        }
        @if (isInReviewMode && !adHocReviewWorkOrderId) {
          <button class="button margin-left" [disabled]="!dataChangeForm.valid" (click)="deny()">Deny</button>
        }
        @if (isInReviewMode) {
          <button class="button margin-left" [disabled]="!dataChangeForm.valid" (click)="addAdHocReview()">Add Ad Hoc review</button>
        }
        @if (isInReviewMode && currentlyAddingAdHocReview) {
          <div>
            <add-ad-hoc-reviewer [workOrderDescription]="getAdHocWorkOrderDescription()" [workOrderTargetUrlPrefix]="getAdHocWorkOrderTargetUrlPrefix()" [workOrderOrgId]="correctionDataInstance.objectOrganizationId"
            [workOrderOrgName]="correctionDataInstance.objectOrganizationName" [applicationNumber]="correctionDataInstance.id" (closeEvent)="toggleAddAdHocReview($event)"></add-ad-hoc-reviewer>
          </div>
        }
      </div>
    }
    @if (correctionDataInstance.submittedDate.userName) {
      <div > <b>Submitted by:</b> {{ correctionDataInstance.submittedDate.userName }} </div>
    }
    @if (correctionDataInstance.status === 'Denied' || correctionDataInstance.status === 'Approved') {
      <div>
        @if (correctionDataInstance.status === 'Denied') {
          <div class="cell large-12"><b>Denied by:</b> {{correctionDataInstance.deniedDate.userName }} <b>Date:</b>  {{correctionDataInstance.deniedDate.date | date: 'MM/dd/yyyy'}}</div>
        }
        @if (correctionDataInstance.status === 'Approved') {
          <div class="cell large-12"><b>Approved by:</b> {{correctionDataInstance.approvedDate.userName }} <b>Date:</b> {{correctionDataInstance.approvedDate.date | date: 'MM/dd/yyyy'}}</div>
        }
        <br /> Click below to return to the dashboard.
      </div>
    }
    <div class="cell large-12"><button class="button margin-left" (click)="onDialogClick()">Return to the dashboard</button></div>
  </div>
}
</div>


